import styled from 'styled-components';
import { border, BorderProps } from 'styled-system';

import { Colors } from 'theme/colors';

export { CircleAction } from './styles.shared';

export const NavSection = styled.nav<BorderProps>`
  border-top: 5px solid ${Colors.emerald};
  background-color: white;
  width: 100%;
  z-index: 1071;
  padding: 10px 0px;
  position: absolute;
  top: 0px;
  right: 0px;
  left: 0px;
  height: 66px;
  display: flex;
  align-items: center;
  transition: border-top-color 0.3s ease;
  ${border};
`;

export const AvatarContainer = styled.div`
  width: 50px;
  height: 50px;
  display: block;
  margin-right: 11px;
  position: relative;

  & ::after {
    content: '';
    display: block;
    width: 11px;
    height: 11px;
    border-radius: 5.5px;
    position: absolute;
    top: 19.5px;
    right: -5.5px;
    background-color: ${Colors.emerald};
  }
`;

export const Avatar = styled.img`
  width: 50px;
  height: 50px;
  border-radius: 25px;
  display: block;
`;
